<template>
    <b-modal id="modalWindow" ref="payment"  centered title="Подтверждение" :ok-only="true" :ok-disabled="!!discount && !comment" ok-title="Подтвердить внесённую оплату"
             @ok="finalConfirmOrder">
        <div v-if="order !== null">
            <h5>Сумма: {{sumPrice()}} {{discount > 0 ? ' - ' + discountPrice + ' = ' + realPrice : ''}} ₽</h5>
            <!--<h5>{{dateDelivery}}</h5>-->
            <br>
            <h5>Наличные</h5>
          <b-input-group class="mt-3">
            <b-form-input type="number"
                          placeholder="Наличные"
                          v-bind:value="valueCash"
                          v-on:input="changeValue ($event, TYPE_PAYMENT.CASH)"
                          v-bind:class="{nonActive: valueCash === 0}"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="success"
                        v-on:click="sumCash"
              >Вся сумма</b-button>
            </b-input-group-append>
          </b-input-group>
            <br>
            <h5>По карте</h5>
            <b-input-group class="mt-3">
            <b-form-input type="number"
                          placeholder="По карте"
                          v-bind:value="valueCard"
                          v-on:input="changeValue ($event,TYPE_PAYMENT.CARD_IN_PLACE)"
                          v-bind:class="{nonActive: valueCard === 0}"
            ></b-form-input>
              <b-input-group-append>
                <b-button variant="success"
                          v-on:click="sumCard"
                >Вся сумма</b-button>
              </b-input-group-append>
            </b-input-group>
            <br>
            <h5>Аванс</h5>
            <b-form-input type="number"
                          placeholder="Аванс"
                          v-model="valueSberbank"
                          :disabled="true"
            ></b-form-input>
            <br>
            <h5>По карте online</h5>
            <b-form-input type="number"
                          placeholder="По карте online"
                          v-model="valueCardOnline"
                          :disabled="true"
            ></b-form-input>
            <br>
            <h5>Платежной ссылкой</h5>
            <b-form-input type="number"
                          placeholder="Платежной ссылкой"
                          v-model="valuePaymentLink"
                          :disabled="true"
            ></b-form-input>
<!--            <br>-->
<!--            <br>-->
<!--            <h5>Скидка (в %)</h5>-->
<!--            <b-form-input type="number"-->
<!--                          placeholder="Скидка"-->
<!--                          v-model.number="discount"-->
<!--            ></b-form-input>-->
<!--            <br>-->
            <!--<h5>Причина скидки</h5>-->
            <!--<b-form-input-->
                          <!--placeholder="Причина скидки"-->
                          <!--v-model="comment"-->
                          <!--:disabled="!permitComment"-->
            <!--&gt;</b-form-input>-->
        </div>
        <b-modal centered title="Неверное местоположение" cancel-title="Попробовать ещё раз" ok-title="Всё-равно продолжить" @ok="openClicker" id="modal-incorrect-geoposition">
          Вы слишком далеко от адреса доставки
        </b-modal>
        <b-modal centered title="Ошибка определения местоположения" ok-only ok-title="Всё-равно продолжить" @ok="openClicker" id="modal-enable-geopos">
          Пожалуйста, включите определение местоположения
        </b-modal>
        <b-modal @shown="startAnimation" @ok="acceptOrder" @hidden="stopAnimation" centered :title="'Кликните ' + rollsCount + ' раз, чтобы продолжить'" ok-only :ok-disabled="numberClicked < rollsCount" id="modal-clicker">
          <hr>
          <div class="text-center"><b class="numberClicker">{{numberClicked}}</b></div>
          <hr>
          <div @click="increaseClick"><img :style="{transform: 'scale(' + iconCurrentSize + ', ' + iconCurrentSize+ ')'}" class="w-100 px-3 mainImage" src="/static/rollClicker.png" alt="Ролл, на который нужно кликать"/></div>
        </b-modal>
    </b-modal>
</template>

<script>
import {CONFIRM_COURIER_ORDER} from '../constants/graphql'
import {courierQueries} from '../graphql/couriers'
import {geolocationPositionToJson} from '../helpers/jsHelpers'
import {TYPE_PAYMENT} from '../constants/keywords'
import ACTIONS from '../constants/vuexActions'

export default {
  name: 'ModalPaymentInfo',
  props: {
    refName: String,
    order: Object,
    pickup: Boolean
  },
  data: function () {
    return {
      vuexNamespace: 'callCenter',
      timerCheckSize: null,
      timerDecreaseSize: null,
      iconNeededSize: 1,
      iconCurrentSize: 1,
      numberClicked: 0,
      discount: 0,
      comment: '',
      valueCash: 0,
      valueCard: 0,
      valueCardOnline: 0,
      valueSberbank: 0,
      valuePaymentLink: 0,
      priceConfirmOrder: 0,
      TYPE_PAYMENT
    }
  },
  created () {
    this.dispatch(ACTIONS.GET_CONFIG_ROLLS_COUNT)
  },
  methods: {
    getter (getter) {
      return this.$store.getters[`${this.vuexNamespace}/${getter}`]
    },
    dispatch (action, payload) {
      this.$store.dispatch(`${this.vuexNamespace}/${action}`, payload)
    },
    acceptOrder () {
      // send payment info and hide payment modal
      this.confirmOrder().then((res) => {
        this.$bvModal.hide('modalWindow')
      }).catch((error) => {
        alert(error.message)
      })
    },
    startAnimation () {
      this.timerCheckSize = setInterval(() => {
        if (this.iconNeededSize > this.iconCurrentSize) {
          this.iconCurrentSize += Math.min(0.005, this.iconNeededSize - this.iconCurrentSize)
        } else {
          this.iconCurrentSize -= Math.min(0.005, this.iconCurrentSize - 1)
        }
      }, 100)
      this.timerDecreaseSize = setInterval(() => {
        this.iconNeededSize = Math.max(1.0, this.iconNeededSize - 0.1)
      }, 1000)
    },
    stopAnimation () {
      clearInterval(this.timerCheckSize)
      clearInterval(this.timerDecreaseSize)
    },
    increaseClick () {
      this.numberClicked++
      this.iconNeededSize = Math.min(this.iconCurrentSize + 0.1, 1.2)
    },
    showModal () {
      this.$refs.payment.show()
    },
    openClicker () {
      this.$bvModal.show('modal-clicker')
    },
    confirmOrder () {
      return this.$apollo.mutate({
        mutation: CONFIRM_COURIER_ORDER,
        variables: {
          id: this.order.id,
          cash: this.valueCash,
          cardInPlace: this.valueCard,
          discount: this.discount,
          cause: this.comment,
          paymentChanged: this.order.paymentChanged
        }
      }).then(() => {
        this.$emit('updated-payment')
      })
    },
    finalConfirmOrder (event) {
      event.preventDefault()
      if (this.pickup) {
        this.acceptOrder()
      } else {
        if (!this.order.paymentChanged) {
          navigator.geolocation.getCurrentPosition(rs => {
            let geoData = JSON.stringify(geolocationPositionToJson(rs))
            this.$apollo.mutate({
              mutation: courierQueries.CHECK_COURIER_POSITION,
              variables: {
                idOrder: this.order.id,
                position: geoData
              }
            }).then((res) => {
              if (res.data.jwtCheckCourierPosition.boolean) {
                this.acceptOrder()
              } else {
                this.$bvModal.show('modal-incorrect-geoposition')
              }
            }).catch((error) => {
              alert(error.message)
              console.error(error)
            })
          // this.confirmOrder()
          }, error => {
            this.$bvModal.show('modal-enable-geopos')
            console.error(error)
          })
        } else {
          this.acceptOrder()
        }
      }
    },
    sumPrice () {
      let sum = 0
      if (this.order) {
        sum = this.order.price - this.valueCardOnline - this.valueSberbank - this.valuePaymentLink
      }
      return sum
    },
    changeValue: function (newValue, typePay) {
      if (typePay === TYPE_PAYMENT.CARD_IN_PLACE) {
        this.valueCard = newValue
        if (this.valueCard > this.realPrice) {
          this.valueCard = this.realPrice
        }
        if (this.valueCard === '') {
          this.valueCard = 0
        }
        this.valueCash = this.realPrice - this.valueCard
      } else if (typePay === TYPE_PAYMENT.CASH) {
        this.valueCash = newValue
        if (this.valueCash > this.realPrice) {
          this.valueCash = this.realPrice
        }
        if (this.valueCash === '') {
          this.valueCash = 0
        }
        this.valueCard = this.realPrice - this.valueCash
      }
    },
    sumCash () {
      this.valueCash = this.realPrice
      this.valueCard = 0
    },
    sumCard () {
      this.valueCard = this.realPrice
      this.valueCash = 0
    }
  },
  watch: {
    order () {
      this.numberClicked = 0
      this.valueCardOnline = this.order.paymentInfo.cardOnline
      this.valueSberbank = this.order.paymentInfo.sberbank
      this.valueCard = this.order.paymentInfo.cardInPlace
      this.valueCash = this.order.paymentInfo.cash
      this.valuePaymentLink = this.order.paymentInfo.paymentLink
      this.priceConfirmOrder = this.order.price - this.valueCardOnline - this.valueSberbank - this.valuePaymentLink
    },
    discount () {
      this.changeValueCard()
    }
  },
  computed: {
    rollsCount () {
      return parseInt(+this.getter('rollsCount'))
    },
    permitComment () {
      return this.discount !== 0 && this.discount !== ''
    },
    realDiscount () {
      return Math.max(0, Math.min(100, this.discount))
    },
    discountPrice () {
      if (this.discount) {
        return Math.ceil(this.realDiscount / 100 * this.sumPrice())
      }
      return false
    },
    realPrice () {
      let sum = this.sumPrice() - this.discountPrice
      return sum
    }
  }
}
</script>

<style scoped>
  .numberClicker {
    font-size: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ModalPaymentInfo.vue